import { Trophy } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export const TopInviterBadge = ({ months = [], size = "sm" }) => {
  const { t } = useI18n();
  const cls = size === "sm" ? "text-[10px] px-2 py-0.5 gap-1" : "text-xs px-3 py-1 gap-1.5";
  const icon = size === "sm" ? "w-3 h-3" : "w-4 h-4";
  return (
    <span
      className={`inline-flex items-center rounded-full font-bold bg-amber-100 text-amber-800 border border-amber-300 ${cls}`}
      title={months.length ? `${t("badge.top_inviter")}: ${months.join(", ")}` : t("badge.top_inviter")}
      data-testid="top-inviter-badge"
    >
      <Trophy className={icon} />
      {t("badge.top_inviter")}{months.length > 1 ? ` ×${months.length}` : ""}
    </span>
  );
};
